import { AssertException } from '../assert.exception';

export class AssertIsStringException extends AssertException {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, AssertIsStringException.prototype);
  }
}
